import { min, max } from 'd3-array';

import Indicator from '../Indicator';

/** Comparative Relative Strength indicator */
export default class CRSIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {Object} - Default parameters object
	 * @property {String} id - Indicator ID
	 * @property {String} name - Indicator name
	 * @property {Object[]} inputs - Indicator inputs
	 * @property {Number} valueMultiplier - Indicator value multiplier. Used to
	 * normalize percent values depending on data - 1 or 100
	 */
	_getDefaultParams() {
		return {
			id: 'crs',
			name: 'Comparative Relative Strength',
			description: 'Comparative Relative Strength (CRS) is a technical analysis indicator that compares the performance of two securities or markets by dividing one security\'s price by the other\'s, helping to identify which one is stronger or weaker relative to each other.',
			inputs: [
				{ name: 'comparisonsymbol', value: '' },
				{ name: 'normalize', value: 1 }
			],
			componentSeries: [
				{ id: 'crs' }
			],
			valueMultiplier: 1
		};
	}

	/**
	 * @param {Object} data - Symbol data object
	 * @return {Number} - d3-range minimum
	 */
	getRangeMin(data) {
		return min(data.crs || [], i => i.crs || -1);
	}

	/**
	 * @param {Object} data - Symbol data object
	 * @return {Number} - d3-range maximum
	 */
	getRangeMax(data) {
		return max(data.crs || [], i => i.crs || 1);
	}

	/**
	 * Renders the indicator
	 * @param {object} data - Symbol data object
	 * @property {string} sessionType - Session type (eg. NormalSession, SessionBreak)
	 */
	render(data, sessionType) {
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
